import { type COLOR_SCHEME } from '../../styling/ColorSchemes';
import { FONT_THEME } from '../../styling/FontSchemes';

export interface HeaderCardElements {
  title?: string;
  variation?: HeaderCardVariationTypes;
  colorScheme?: COLOR_SCHEME;
  logoSrc?: string;
  fontScheme?: (typeof FONT_THEME)[keyof typeof FONT_THEME];
  height?: string;
  isFixed?: boolean; // when false, renders inline (for previews)
  padding?: string; // custom container padding; defaults to "clamp(0.75rem, 1.8vw, 1rem) clamp(1rem, 3vw, 2rem)"
  brandHref?: string | null; // null keeps preview headers non-navigable
  showBrandDetails?: boolean;
  showGetStartedButton?: boolean; // when true, displays "Get Started" button on right side
  onGetStartedClick?: () => void; // callback when Get Started button is clicked
}

export enum HeaderCardVariationTypes {
  CLASSIC = 'Classic',
  STRIPE = 'Stripe',
  ABSTRACT = 'Abstract',
  CHECKERED = 'Checkered',
  BOLD_GRADIENT = 'Bold Gradient',
  MINIMAL = 'Minimal',
  SOLID = 'Solid',
}
